import moment from "moment";
import { EntPersonellFilter } from "../../../models/filters/personellFilter";
import { EntPersonnel } from "../../../models/personnel";
import { EntPersonnelItem } from "../../../models/personnelItem";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { BlobResponse, EntReportPayload } from "../../../models/report";
import { Paths } from "../../../paths";
export const personnelApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

    getPersonnelListFiltered: builder.query<ResponseDataGet<EntPersonnelItem>, EntPersonellFilter>({
      query: (filter) => ({
        url: `${ Paths.registries.personel }/get-all`,
        method: "POST",
        body: JSON.stringify(filter, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return moment(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    getPersonnelList: builder.query<ResponseDataGet<EntPersonnel>, void>({
      query: (id) => ({
        url: `${ Paths.registries.personel }`,
        method: 'GET'
      })
    }),
    getPersonnelAnalyticalData: builder.query<ResponseDataGet<EntPersonnel>, string>({
      query: (alias) => ({
        url: `${ Paths.registries.personel }/analytical-data?governmentAlias=${alias}`,
        method: 'GET'
        
      })
    }),
    getPersonnelById: builder.query<ResponseDataTest<EntPersonnelItem>, number>({
      query: (id) => ({
        url: `${ Paths.registries.personel }/${id}`,
        method: 'GET'
      })
    }),
    addPersonnel: builder.mutation<ResponseDataTest<EntPersonnelItem>, EntPersonnelItem>({
      query: (body) => ({
        url: `${ Paths.registries.personel }`,
        method: "POST",
        body: JSON.stringify(body, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return moment(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    editPersonnel: builder.mutation<ResponseDataTest<EntPersonnelItem>, EntPersonnelItem>({
      query: (body,) => ({
        url: `${ Paths.registries.personel }`,
        method: 'PUT',
        body: JSON.stringify(body, (key, value) => {
          if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
            return moment(value).format('YYYY-MM-DD')
          }
          return value;
        })
      }),
    }),
    deletePersonnel: builder.mutation<ResponseDataTest<EntPersonnelItem>, number>({
      query: (id) => ({
        url: `${ Paths.registries.personel }/${id}`,
        method: 'DELETE',
      }),
    }),
    reportPersonnel: builder.mutation<BlobResponse, EntReportPayload>({
      query: (payload) => {
        const { language, governmentAlias } = payload;

        return {
          url: `/report${ Paths.registries.personel }`,
          method: "POST",
          params: {
            language,
            governmentAlias,
          },
          body: JSON.stringify(payload),
          responseHandler: (response) => response.blob(),
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddPersonnelMutation,
  useDeletePersonnelMutation,
  useEditPersonnelMutation,
  useGetPersonnelAnalyticalDataQuery,
  useLazyGetPersonnelListFilteredQuery,
  useReportPersonnelMutation
} = personnelApi;
